import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { show_color_picker, showing_color_picker } from '@features/color-picker';
import show_colors_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/colors.svg';
import { img } from '@phi/components';
import ShowColorsTooltip from './ShowColorsTooltip';

export const ColorPickerIcon = show_colors_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    methods: {
        onClick(e: MouseEvent) {
            show_color_picker(e);
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show Colour Picker';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    render() {
        return h(BarButton, {
            ref: 'button',
            id: 'show-colors-modal-button',
            disabled: this.disabled,
            tippy: 'top',
            selected: this.state.tut_stage === 3,
            active: showing_color_picker.value,
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_colors_svg, this.alt),
            tooltip: ShowColorsTooltip,
        });
    },
});
